import React, { useContext, useEffect, useState } from "react";

import { Form, Formik, FormikProps } from "formik";

import DataFetch from "../../../../../../../images/OpenIcon.svg";

import { TextField } from "@mui/material";
import Close from "../../../../../../../images/Close.svg";
import { rfqPoFormData } from "../../../../../../../utils/formTypes";
import { AppContext } from "../../../../../../../context/context";
import { Operation } from "../../../../../../../utils/Enum.types";
import { Title } from "../../../../../../../stories/Title/Title";
import { LabelProps } from "../../../../../../../utils/types";
import { Label } from "../../../../../../../stories/Label/Label";
import TextArea from "../../../../../../../stories/TextArea/TextArea";
import {
  CustomModal,
  handleFormEvent,
  handleMUISelectEvent,
  hanldeTextAreaFormEvent,
  toStandardDate,
} from "../../../../../../../utils/UtilFunctions";
import InputNumber from "../../../../../../common/Input/InputNumber";
import RFQSelect from "./RFQSelect";
import { AtsRfqMstEdge, AtsRfqTrn } from "../../../quotation/queries/types";
import { payloadTypes } from "../../../../../../../context/reducer";
import InputHoc from "../../../../../../common/Input/Index";
import { Button } from "../../../../../../../stories/Button/Button";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../../../../styles/AutocompleteStyles";
import { ViewModalStyles } from "../../../../../../../styles/CustomModalStyles";
import RfqItems from "../RfqItems";
import { rfqPoAddItem } from "../../../../../../../utils/validationSchema";
import { Keys } from "../../../../../../../utils/Enum.keys";
import useLabels from "../../../../../../../customHooks/useLabels";
import useFormJson from "../../../../../../../json/useFormJson";
interface formDataProp {
  formData: rfqPoFormData;
  setFormData: React.Dispatch<React.SetStateAction<rfqPoFormData>>;
}

interface rfqAndItemProp {
  editRfq: AtsRfqMstEdge | null;
  editItm: AtsRfqTrn | null;
}
interface Props {
  operation: Operation;
  hanldeItemRow: (formData: rfqPoFormData) => void;
  itemsCount: number;
  setModal: (value: React.SetStateAction<boolean>) => void;
  formDataState: formDataProp;
  editState: rfqAndItemProp;
}

const AddRfqModal = ({
  operation,
  hanldeItemRow,
  itemsCount,
  setModal,
  formDataState,
  editState,
}: Props) => {
  const initialValues: rfqPoFormData = {
    slNo: "",
    rfqTrnSlNo: 0,
    udfItemDesc: "",
    itemUom: "",
    itemQty: "",
    itemRate: "",
    itemOther: "",
    itemTaxable: "",
    itemTax: "",
    itemDelvChrg: "",
    itemInstChrg: "",
    itemValue: "",
    remarks: "",
    itemDeliverySts: "",
    itemDeliveryDate: "",
    itemID: 0,
    rfqTrnID: 0,
    rfqID: 0,
    rfqDate: "",
    rfqNo: "",
    netTotal: 0,
  };

  const { dispatch } = useContext(AppContext);
  const { formData, setFormData } = formDataState;
  const [selectedRfq, setSelectedRfq] = useState<AtsRfqMstEdge | null>(null);
  const [selectedItm, setSelectedItm] = useState<AtsRfqTrn | null>(null);
const {RFQPOAdd}=useFormJson();
  const [itemDescription, setItemDescription] = useState(false);

  const { editItm, editRfq } = editState;

  const selectRfq = (rfq: AtsRfqMstEdge | null) => {
    if (rfq) {
      setSelectedRfq(rfq as AtsRfqMstEdge);

      dispatch({
        type: payloadTypes.SET_RFQ_ID,
        payload: {
          rfqId: (rfq as AtsRfqMstEdge).node.id,
        },
      });

      setFormData({
        ...formData,
        rfqID: (rfq as AtsRfqMstEdge).node.id,
        rfqDate: toStandardDate(rfq.node.rfqDate),
        rfqNo: rfq.node.rfqNo,
      });
    } else {
      setSelectedRfq(null);
      dispatch({
        type: payloadTypes.SET_RFQ_ID,
        payload: {
          rfqId: 0,
        },
      });
      setFormData(initialValues);
    }
  };

  const handleClear = () => {
    setFormData(initialValues);
  };

  const selectItem = (rfq: AtsRfqTrn | null) => {
    if (rfq) {
      setSelectedItm(rfq as AtsRfqTrn);
      const other =
        rfq.mrf_trn_details.approxDlvryRate +
        rfq.mrf_trn_details.approxInstRate +
        rfq.mrf_trn_details.approxOtherRate;

      const taxableRate =
        (rfq.trnQty * rfq.approxRate + other) * (rfq.mrf_trn_details.tax / 100);
      setFormData({
        ...formData,
        udfItemDesc: rfq.udfItemDesc,
        itemUom: rfq.item.uom,
        itemQty: rfq.trnQty.toString(),
        itemRate: rfq.approxRate.toString(),
        itemOther: other.toString(),
        itemTaxable: taxableRate.toString(),
        itemTax: rfq.mrf_trn_details.tax.toString(),
        itemValue: (rfq.trnQty * rfq.approxRate + other).toString(),
        itemInstChrg: rfq.mrf_trn_details.approxInstRate.toString(),
        itemDelvChrg: rfq.mrf_trn_details.approxDlvryRate.toString(),
        itemDeliverySts: "0",
        itemID: rfq.item.id,
        rfqTrnID: rfq.id,
        rfqTrnSlNo: rfq.slNo,
        netTotal: rfq.trnQty * rfq.approxRate + other + taxableRate,
      });
    } else {
      setSelectedItm(null);
      setFormData({
        ...formData,
        ...initialValues,
      });
    }
  };
  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<rfqPoFormData>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
    meta.handleChange(e);
  };

  const handleForm = () => {
    hanldeItemRow(formData);
    setSelectedItm(null);
    setSelectedRfq(null);
  };
  const handleSubmit = () => {
    setModal(false);
    hanldeItemRow(formData);
    setSelectedItm(null);
    setSelectedRfq(null);
  };
  useEffect(() => {
    if (operation === Operation.UPDATE) {
      setSelectedRfq(editRfq);
      setSelectedItm(editItm);
    }
  }, [operation, editRfq, editItm]);
const {itemLabel}=useLabels();
  return (
    <>
      <div className="material-item-add">
        <div className="material-item-add__title">
          <Title>Add Rfq</Title>
          <img src={Close} alt="" onClick={() => setModal(false)} />
        </div>

        <Formik
          initialValues={formData}
          validationSchema={rfqPoAddItem}
          onSubmit={handleForm}
          enableReinitialize
          validateOnChange
        >
          {(meta) => {
            return (
              <Form className="material-item-add__form">
                <div className="material-item-add__form--details row g-0">
                  <div className="material-item-add__form--details--left col">
                    {RFQPOAdd.AddItem.leftForm.map(
                      (field: LabelProps, key: React.Key) => {
                        if (field.dataType === "number") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <InputNumber
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  disabled={field.disabled}
                                  name={field.inputName}
                                  required={field.required}
                                  maxLength={field.maxLength}
                                  onKeyDown={handleFormEvent}
                                  className={field.className}
                                />
                              </div>
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "rfqs") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <div className="material-item-add__form--details--flex">
                                  <RFQSelect
                                    onChange={(newValue) => {
                                      selectRfq(newValue);
                                    }}
                                    onKeyDown={(e) => {
                                      if (e.key === Keys.ENTER) {
                                        handleMUISelectEvent(e);
                                      }
                                    }}
                                    autofocus={true}
                                    value={selectedRfq}
                                  />
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        } else if (field.dataType === "items") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{itemLabel} Description</Label>
                                <div className="material-item-add__form--details--flex">
                                  <FormAutocomplete
                                    className={formClasses.inputRoot}
                                    options={
                                      selectedRfq
                                        ? selectedRfq.node.rfqTrnDetails
                                        : []
                                    }
                                    onKeyDown={(e: React.KeyboardEvent) => {
                                      if (e.key === Keys.ENTER) {
                                        handleMUISelectEvent(e);
                                      }
                                    }}
                                    getOptionLabel={(option: any) =>
                                      (option as AtsRfqTrn).udfItemDesc
                                    }
                                    value={selectedItm}
                                    onChange={(e, newValue) => {
                                      selectItem(newValue as AtsRfqTrn | null);
                                    }}
                                    openOnFocus
                                    forcePopupIcon
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        fullWidth
                                        className={formClasses.formControlRoot}
                                      />
                                    )}
                                  />

                                  <img
                                    src={DataFetch}
                                    alt=""
                                    className="data-fetch-icon"
                                    onClick={() =>
                                      setItemDescription(!itemDescription)
                                    }
                                  />
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        } else {
                          return (
                            <React.Fragment key={key}>
                              <InputHoc
                                LabelName={field.labelName}
                                values={formData[field.inputName]}
                                name={field.inputName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                required={field.required}
                                autoFocus={field.autoFocus}
                                onKeyDown={handleFormEvent}
                                disabled={field.disabled}
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        }
                      }
                    )}
                  </div>
                  <div className="material-item-add__form--details--right col">
                    {RFQPOAdd.AddItem.rightForm.map(
                      (field: LabelProps, key: React.Key) => {
                        if (field.dataType === "textarea") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <TextArea
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLTextAreaElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  type={field.dataType}
                                  rows={3}
                                  name={field.inputName}
                                  onKeyDown={(e) => {
                                    hanldeTextAreaFormEvent(
                                      e,
                                      setFormData as React.Dispatch<
                                        React.SetStateAction<{
                                          [key: string]: string | number;
                                        }>
                                      >
                                    );
                                  }}
                                />
                              </div>
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "number") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <InputNumber
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  name={field.inputName}
                                  required={field.required}
                                  maxLength={field.maxLength}
                                  className={field.className}
                                  onKeyDown={handleFormEvent}
                                  disabled={field.disabled}
                                />
                              </div>
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else {
                          return (
                            <React.Fragment key={key}>
                              <InputHoc
                                LabelName={field.labelName}
                                values={formData[field.inputName]}
                                name={field.inputName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                type={field.dataType}
                                required={field.required}
                                autoFocus={field.autoFocus}
                                onKeyDown={handleFormEvent}
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        }
                      }
                    )}
                  </div>
                </div>
                <div className="row g-0">
                  <div className="col">
                    <Button
                      mode={
                        operation === Operation.CREATE
                          ? "save-continue"
                          : "save"
                      }
                      type="submit"
                    >
                      {operation === Operation.CREATE ? (
                        <>&nbsp;({itemsCount})</>
                      ) : null}
                    </Button>
                    <Button mode="clear" onClick={handleClear} type="button" />
                    <Button
                      mode="cancel"
                      onClick={() => {
                        dispatch({
                          type: payloadTypes.SET_RFQ_ID,
                          payload: {
                            rfqId: 0,
                          },
                        });
                        setFormData(initialValues);
                        setModal(false);
                      }}
                      type="button"
                    />
                  </div>
                  {operation === Operation.CREATE ? (
                    <div className="col flex-end">
                      <Button
                        mode="save"
                        onClick={() => {
                          handleSubmit();
                        }}
                        type="button"
                      />
                    </div>
                  ) : null}
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
      <CustomModal
        isOpen={itemDescription}
        onRequestClose={() => setItemDescription(false)}
        contentComponent={<RfqItems setModalFlag={setItemDescription} />}
        style={ViewModalStyles}
      />
    </>
  );
};

export default AddRfqModal;
